<template>
    <div class="tag" :class="tagClass" :style="'width: ' + this.width + 'px'">
        {{ label }}
    </div>
</template>

<script>
export default {
    name: "CTag",

    props: {
        label: {
            required: true,
        },

        width: {
            required: false,
            type: Number,
            default: function () {
                return 29;
            }
        },

        selected: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        active: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        backgroundColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },

        highlight: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        }
    },

    computed: {
        tagClass () {
            if (this.highlight) {
                if (this.active > 0) return "highlight-active ";
                return "highlight-inactive";
            }

            if (this.selected) {
                if (this.active > 0) return "white-border primary-background white--text"
                return "white primary--text white-border";
            }

            if (this.active > 0) return this.backgroundColor +  " white--text"
            return this.backgroundColor + "--text " + this.backgroundColor + "-border";
        }
    }
}
</script>

<style scoped>

.tag {
    width: 25px;
    text-align: center;
    font-size: 11px;
    margin-top: 2px;
    height: 18px;
    line-height: 18px;
    border-radius: 2px;
    padding-top: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 2px;
    padding-right: 2px;
}

.highlight-active {
    background-color: orange;
    color: white;

}

.highlight-inactive {
    border-width: 1px;
    border-style: solid;
    border-color: orange!important;
    color: orange;
}


</style>